import React from "react";
import styles from "./TicketUploadDetails.module.scss";
import { Row, Col, Skeleton } from "antd";
import { getTicketDetailValues } from "./constants";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";

const TicketProcessingDetails = ({
  ticketData,
  isLoading,
}: {
  ticketData: any;
  isLoading: boolean;
}) => {
  const ticketDetails = getTicketDetailValues(ticketData);

  return (
    <div className={styles.processingDetailsWrapper}>
      <ConditionalRender
        visible={!!!isLoading}
        fallback={
          <>
            <div className={styles.sectionContainer}>
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>
            <div className={styles.sectionContainer}>
              <Skeleton active paragraph={{ rows: 7 }} />
            </div>
            <div className={styles.sectionContainer}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
          </>
        }
      >
        {ticketDetails?.map(([headers, content]) => {
          return (
            <div className={styles.sectionContainer}>
              <div className={styles.sectionLabel}>{headers}</div>
              {content?.map(([label, value, labelSpan, contentSpan], index) => {
                return (
                  <div className={styles.tableRowWrapper} key={index}>
                    <Row>
                      <Col span={labelSpan}>
                        <div className={styles.tableLabel}>{label}</div>
                      </Col>
                      <Col span={contentSpan}>
                        <div className={styles.tableContent}>{value}</div>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </div>
          );
        })}
      </ConditionalRender>
    </div>
  );
};

export default TicketProcessingDetails;
